/** @prettier */
import { connect } from 'react-redux';

import { dismissBanner } from '@xanadu/ui-shared/modules/application/actions';

import GlobalBanner from '../../components/GlobalBanner';

const mapDispatchToProps = {
  dismissBanner,
};

function mapStateToProps(state) {
  return {
    bannerBackgroundColor: state.getIn(['application', 'bannerBackgroundColor']),
    bannerDismissBehaviour: state.getIn(['application', 'bannerDismissBehaviour']),
    globalBannerMessage: state.getIn(['application', 'globalBannerMessage']),
    globalBannerPortal: state.getIn(['application', 'globalBannerPortal']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalBanner);
